"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PxtTelemetryWindowConfigHelper = void 0;
const INITIAL_PXT_TELEMETRY_CONFIG = {
    automaticPageImpressionTrackingEnabled: true,
};
class PxtTelemetryWindowConfigHelper {
    constructor(windowGetter) {
        this.windowGetter = windowGetter;
        this.disableAutomaticPageImpressionTracking = () => {
            const window = this.windowGetter();
            if (typeof window === "undefined") {
                console.warn("Cannot disable automatic page impressions from the server. Please call disableAutomaticPageImpressionTracking clientside");
                return;
            }
            if (!window.PxtTelemetryConfig) {
                window.PxtTelemetryConfig = INITIAL_PXT_TELEMETRY_CONFIG;
            }
            window.PxtTelemetryConfig.automaticPageImpressionTrackingEnabled = false;
        };
    }
}
exports.PxtTelemetryWindowConfigHelper = PxtTelemetryWindowConfigHelper;
